import { render, staticRenderFns } from "./notification.view.vue?vue&type=template&id=273ca9ae&"
import script from "./notification.view.vue?vue&type=script&lang=js&"
export * from "./notification.view.vue?vue&type=script&lang=js&"
import style0 from "./notification.view.vue?vue&type=style&index=0&id=273ca9ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports